import styled from "styled-components";

export const CancelaOrdenDigitalLaboratorioContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
`;
export const CancelaOrdenDigitalLaboratorioBody = styled.div`
  max-width: 400px;
  padding: 20px;
`;
export const CancelaOrdenDigitalLaboratorioBotones = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 12px;
`;
